import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <p className="footer-section">&copy; Developed by Monika Maurya... </p>
    </div>
  );
};

export default Footer;
